// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Moment from 'moment'
import './plugins/element.js'
import '@/styles/index.less'
import './icons'
import './assets/icon/iconfont.css'
import './permission'
Vue.config.productionTip = false
Vue.prototype.moment = Moment
// 引入mock.js
// require('./mock.js')

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js